import { AgentMode } from '@commenda/types';

import type { IComposerControlsConfig } from './types';

/** Which composer controls a surface's config turns on. */
export class ComposerControlsHelper {
  static readonly MODE_OPTIONS: readonly { value: AgentMode; label: string }[] =
    [
      { value: AgentMode.PLAN, label: 'Plan' },
      { value: AgentMode.AGENT, label: 'Agent' },
    ];

  static getModeName(mode: AgentMode): string {
    return (
      ComposerControlsHelper.MODE_OPTIONS.find(
        (option) => option.value === mode
      )?.label ?? 'Agent'
    );
  }

  /** The composer draws a divider before its footer controls, so it must only be handed them when
   * at least one will actually render. */
  static hasFooterControls(
    composerControls: IComposerControlsConfig | undefined
  ): boolean {
    if (!composerControls) return false;
    return Boolean(
      composerControls.profilePicker ||
        composerControls.modeConfig ||
        composerControls.modelConfig?.models.length
    );
  }
}
